// extracted by mini-css-extract-plugin
export default {"warning_icon":"WarningIcon_warning_icon__72xxE"};